import { apiGet } from '@/api/mutator';

import type { PlanAccessResponse } from './plan-access';

/**
 * `GET /billing/plan-access` (C4) — the ONE read of the lock family.
 *
 * Hand-written only until checkpoint C1: the committed `backend/openapi.json`
 * predates the route (plan-gates fills the controller in parallel), so the
 * generated client has no function for it yet. At C1 the integrator replaces
 * this body with the generated caller; the signature, and every test that
 * mocks this module, stay as they are. Its own module so a test can replace
 * the transport without replacing the lock logic in `plan-access.ts`.
 */
export function fetchPlanAccess(signal?: AbortSignal): Promise<PlanAccessResponse> {
  return apiGet<PlanAccessResponse>('/billing/plan-access', undefined, signal);
}
